import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import WhatsAppWidget from './components/WhatsAppWidget';
import ScrollToTop from './components/ScrollToTop';
import ContactPopup from './components/ContactPopup';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import PartnerProgram from './pages/PartnerProgram';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import Careers from './pages/Careers';
import { initScrollTracking } from './utils/analytics';
import './App.css';

// Scroll to top on route change
function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [showContactPopup, setShowContactPopup] = useState(false);

  const openPopup = () => setShowContactPopup(true);

  useEffect(() => {
    // Initialize scroll tracking for analytics
    const cleanup = initScrollTracking();
    return cleanup;
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTopOnRouteChange />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home onOpenPopup={openPopup} />} />
              <Route path="/services" element={<Services onOpenPopup={openPopup} />} />
              <Route path="/pricing" element={<Pricing onOpenPopup={openPopup} />} />
              <Route path="/partner-program" element={<PartnerProgram />} />
              <Route path="/about" element={<About />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/careers" element={<Careers />} />
              {/* Fallback to home */}
              <Route path="*" element={<Home onOpenPopup={openPopup} />} />
            </Routes>
          </main>
          <Footer />
          <StickyCTA onOpenPopup={() => setShowContactPopup(true)} />
          <WhatsAppWidget />
          <ScrollToTop />
          <PWAInstallPrompt />
          <ContactPopup 
            isOpen={showContactPopup} 
            onClose={() => setShowContactPopup(false)} 
          />
          <Toaster />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;